import api, { CRM_LOSS_REASONS } from './api.ts';
export type CrmLossReason = { id: number; name: string; requires_observation: boolean };
export type ReasonCatalog = { items: CrmLossReason[]; can_manage: boolean; legacy?: boolean };
const path = (client: number, clinic: number) => `/api/agenda/clients/${client}/clinics/${clinic}/crm/loss-reasons`;
export async function getLossReasons(client: number, clinic: number, allowLegacy = false): Promise<ReasonCatalog> {
  try { return (await api.get(path(client, clinic))).data; }
  catch (error: any) {
    if (allowLegacy && error?.response?.status === 404) return {
      items: CRM_LOSS_REASONS.map((name, index) => ({ id: -(index + 1), name, requires_observation: name === 'Outro' })), can_manage: false, legacy: true,
    };
    throw error;
  }
}
export async function saveLossReason(client: number, clinic: number, payload: Pick<CrmLossReason, 'name' | 'requires_observation'>, id?: number) {
  return (await (id ? api.patch(`${path(client, clinic)}/${id}`, payload) : api.post(path(client, clinic), payload))).data;
}
export async function deleteLossReason(client: number, clinic: number, id: number) {
  return api.delete(`${path(client, clinic)}/${id}`);
}
export function getReasonScope() {
  const clientId = Number(localStorage.getItem(localStorage.getItem('user_type') === 'user' ? 'master_client_id' : 'client_id'));
  const clinicId = Number(localStorage.getItem('clinic_id'));
  if (!clientId || !clinicId) throw new Error('Selecione uma clínica para configurar os motivos.');
  return { clientId, clinicId };
}
